// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getProfileProfessional } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";
import { getMobileRedirectionAuthToken } from "../../Helper/mobileAuth";

const resolveProfessionalAuthToken = (tokenParam) => {
  if (tokenParam) {
    return tokenParam;
  }
  const mobileToken = getMobileRedirectionAuthToken();
  if (mobileToken) {
    return mobileToken;
  }
  return localStorage.getItem("professionalToken") || "";
};

export const hitGetProfileApi = createAsyncThunk(
  "hitGetProfileApi",
  async (token = null) => {
    try {
      const authToken = resolveProfessionalAuthToken(token);
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${authToken}`,
        },
      };
      const url = ApiBaseUrl + getProfileProfessional;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      const status = error?.response?.status;
      if (status !== 401) {
        const message =
          error?.response?.data?.message || "Failed to load profile.";
        showToast(message, "error");
      }
      throw error?.response?.data || error;
    }
  }
);

const GetProfileSlice = createSlice({
  name: "getProfileProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetProfileData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetProfileApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetProfileApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetProfileApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetProfileData } = GetProfileSlice.actions;
export default GetProfileSlice.reducer;
